export const ACCOUNT_NUMBER_LENGTH = 8;
export const SORT_CODE_LENGTH = 6;
export const MAX_BANKNAME_FIELD_LENGTH = 100;

export type OrderableColumns = "active" | "currency" | "nickname";
